import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SessionQuery} from 'phd-akita-session';

@Injectable({
  providedIn: 'root'
})
export class HttpAuthInterceptor implements HttpInterceptor {

  constructor(private sess: SessionQuery) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.sess.getValue().user) {
      request = request.clone({
        withCredentials: true,
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + this.sess.getValue().user.token
        }),
      });
    }
    return next.handle(request);
  }
}
